module.exports = __webpack_public_path__ + "img/PointsOfInterest.76c2e14b.png";